<template>
  <div class="home">
    <!-- 背景和返回首页按钮保持不变 -->
    <div class="background">
      <!-- <vue-particles
        color="#00aeff"
        :particleOpacity="0.7"
        :particleOpacityRandom="true"
        :particlesNumber="140"
        shapeType="circle"
        :particleSize="4"
        linesColor="#8EB5C9"
        :linesWidth="1"
        :lineLinked="false"
        :lineOpacity="0.6"
        :linesDistance="120"
        :moveSpeed="1"
        :hoverEffect="false"
        hoverMode="grab"
        :clickEffect="false"
        clickMode="push"
      >
      </vue-particles> -->
    </div>
    
    <!-- <div class="backhome" @click="backHome()">
      <i class="el-icon-s-home"></i>
    </div> -->

    <!-- 全屏 / 返回主页两个按钮已挪进右侧「异常提醒」那一行的头部（DashboardRightAlarm），
         与主页按钮同排、同尺寸，故这里不再单独浮动 -->
    
    <!-- 修改dashboard-container的子组件宽度 -->
    <div class="dashboard-container">
        <!-- 左侧区域：40%宽度 -->
        <div class="left-column">
          <DashboardLeftCharts
            :contract-info-of-month="dashboardData && dashboardData.contractInfoOfMonth"
            :contract-info-of-year="dashboardData && dashboardData.contractInfoOfYear"
          />
        </div>

        <!-- 中间区域：40%宽度 -->
        <div class="center-column">
          <DashboardCards :dashboard-data="dashboardData" @timeRangeChange="onTimeRangeChange" />
        </div>

        <!-- 右侧区域：20%宽度 -->
        <div class="right-column">
          <DashboardRightAlarm
            :exception-list="dashboardData && dashboardData.exception"
          />
        </div>
    </div>
  </div>
</template>

<script>
// 导入组件
import DashboardLeftCharts from './components/DashboardLeftCharts.vue';
import DashboardCards from './components/DashboardCards.vue';
import DashboardRightAlarm from './components/DashboardRightAlarm.vue';
import { getDashboardCardData } from '@/api/mainapi.js'
import UserInfoUtils from '@/utils/userInfoUtils.js'

export default {
  name: 'dashboard',
  // 注册组件
  components: {
    DashboardLeftCharts,
    DashboardCards,
    DashboardRightAlarm
  },
  data() {
    return {
      dashboardData: null,
      currentTimeRange: 'month',
    }
  },
  mounted() {
    this.loadDashboardData()
  },
  methods: {
    /**
     * 时间范围切换回调
     */
    onTimeRangeChange(range) {
      this.currentTimeRange = range
      this.loadDashboardData()
    },
    /**
     * 加载驾驶舱数据
     */
    async loadDashboardData() {
    try {
      const now = new Date()
      let startDateStr, currentDateStr

      if (this.currentTimeRange === 'year') {
        // 本年：从今年1月1日开始
        const startDate = new Date(now.getFullYear(), 0, 1)
        startDateStr = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`

        // 当天
        const today = new Date(now)
        today.setDate(now.getDate())
        currentDateStr =
          `${today.getFullYear()}-` +
          `${String(today.getMonth() + 1).padStart(2, '0')}-` +
          `${String(today.getDate()).padStart(2, '0')}`


        // 前一天
        // const yesterday = new Date(now)
        // yesterday.setDate(now.getDate() - 1)
        // currentDateStr =
        //   `${yesterday.getFullYear()}-` +
        //   `${String(yesterday.getMonth() + 1).padStart(2, '0')}-` +
        //   `${String(yesterday.getDate()).padStart(2, '0')}`
      } else {
        // 本月：从本月第一天开始
        const startDate = new Date(now.getFullYear(), now.getMonth(), 1)
        startDateStr = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`

        // 前一天
        // const yesterday = new Date(now)
        // yesterday.setDate(now.getDate() - 1)
        // currentDateStr =
        //   `${yesterday.getFullYear()}-` +
        //   `${String(yesterday.getMonth() + 1).padStart(2, '0')}-` +
        //   `${String(yesterday.getDate()).padStart(2, '0')}`
      
        // 当天
        const today = new Date(now)
        today.setDate(now.getDate())
        currentDateStr =
          `${today.getFullYear()}-` +
          `${String(today.getMonth() + 1).padStart(2, '0')}-` +
          `${String(today.getDate()).padStart(2, '0')}`
      }

      const res = await getDashboardCardData({
        startDate: startDateStr,
        currentDate: currentDateStr
      })

        if (res.data.code === 200) {
          this.dashboardData = res.data.data
        }
      } catch (e) {
        console.error('驾驶舱数据加载失败', e)
      }
    },
  
    backHome() {
      // 返回主页：按权限决定（有项目管理权限→项目主页，否则→合同主页），避免跳转到无权限的项目页
      this.$router.push(UserInfoUtils.getDefaultHomeRoute());
    },

  }
};
</script>

<style scoped>
.home {
  width: 100%;
  height: 100vh;
  background: url(~@/assets/images/index_bg.png) left top no-repeat;
  background-size: 100% 100%;
  display: flex;
  outline: none;
  overflow: hidden;
  position: relative;
}

.backhome {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 28px;
  color: #0595EB;
  z-index: 999;
  cursor: pointer;
  background: rgba(5, 149, 235, 0.1);
  padding: 5px 10px;
  border-radius: 4px;
  border: 1px solid rgba(5, 149, 235, 0.3);
}

.backhome:hover {
  color: #fff;
  background: rgba(5, 149, 235, 0.3);
}

/* 原生全屏 / 兜底伪全屏时都要铺满整个屏幕
   （全屏按钮在 DashboardRightAlarm 里，切换时由它给这个根元素挂 .is-fs） */
.home:fullscreen { width: 100vw; height: 100vh; }
.home.is-fs {
  position: fixed !important; inset: 0; z-index: 1200;
  width: 100vw; height: 100vh;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.dashboard-container {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  z-index: 2;
  position: relative;
  gap: 20px; /* 添加列间距 */
}

/* 左侧栏：占整个页面的40% */
.left-column {
  flex: 3;  /* 使用flex比例，实现40% */
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 0; /* 允许内容缩小 */
  overflow: hidden; /* 防止溢出 */
}

/* 中间栏：占整个页面的40% */
.center-column {
  flex: 5;  /* 使用flex比例，实现40% */
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 0; /* 允许内容缩小 */
  overflow: hidden; /* 防止溢出 */
}

/* 右侧栏：异常提醒（收窄一点，把宽度让给中间区域） */
.right-column {
  flex: 1.5;  /* 由 2 收窄到 1.5，约 15% */
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 0; /* 允许内容缩小 */
  overflow: hidden; /* 防止溢出 */
}
</style>